<template>

  <header class="site-header">

    <div class="container site-header__inner">

      <router-link to="/" class="site-brand" aria-label="GB WhatsApp — GBWaps home">

        <img :src="logoUrl" alt="GB WhatsApp" class="site-brand-logo" width="40" height="40">

        <span class="site-brand-text">

          <span class="site-brand-name">GB WhatsApp</span>

          <span class="site-brand-muted">GBWaps Guide</span>

        </span>

      </router-link>



      <nav

        class="site-primary-nav"

        :class="{ 'site-primary-nav--open': menuOpen }"

        aria-label="Primary"

      >

        <ul class="site-primary-nav__list">

          <li v-for="link in navLinks" :key="link.path">

            <a

              :href="link.path"

              :class="{ 'is-active': isActive(link.path) }"

              @click="onNavClick($event, link.path)"

            >{{ link.label }}</a>

          </li>

        </ul>

      </nav>



      <button

        type="button"

        class="mobile-menu-toggle"

        aria-label="Toggle menu"

        :aria-expanded="menuOpen ? 'true' : 'false'"

        @click="menuOpen = !menuOpen"

      >

        {{ menuOpen ? '✕' : '☰' }}

      </button>

    </div>

  </header>

</template>



<script>

import { LOGO_URL, MAIN_NAV } from '@/config/gbwaps';



export default {

  name: 'SiteHeader',

  data() {

    return {

      menuOpen: false,

      logoUrl: LOGO_URL,

      navLinks: MAIN_NAV,

    };

  },

  methods: {

    isActive(path) {

      const current = this.$route.path;

      if (path === '/') return current === '/';

      return current === path || current.startsWith(`${path}`);

    },

    onNavClick(event, path) {

      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {

        return;

      }

      event.preventDefault();

      this.menuOpen = false;

      if (this.$route.path !== path) {

        this.$router.push(path).catch(() => {});

      }

    },

  },

  watch: {

    $route() {

      this.menuOpen = false;

    },

  },

};

</script>



<style scoped>

.site-header {

  position: sticky;

  top: 0;

  z-index: 2000;

  background: #fff;

  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

  isolation: isolate;

}



.site-header__inner {

  display: flex;

  align-items: center;

  justify-content: space-between;

  gap: 20px;

  padding-top: 16px;

  padding-bottom: 16px;

  overflow: visible;

}



.site-brand {

  flex: 0 0 auto;

}



.site-primary-nav {

  flex: 0 0 auto;

  display: flex;

  align-items: center;

  position: relative;

  z-index: 2001;

  background: #fff;

}



.site-primary-nav__list {

  display: flex;

  flex-wrap: nowrap;

  align-items: center;

  gap: 16px;

  margin: 0;

  padding: 0;

  list-style: none;

}



.site-primary-nav__list li {

  flex: 0 0 auto;

}



.site-primary-nav__list a {

  display: inline-block;

  font-family: 'Poppins', var(--font-heading, sans-serif);

  font-weight: 500;

  font-size: 0.95rem;

  color: #1f1f1f !important;

  white-space: nowrap;

  text-decoration: none;

  line-height: 1.2;

  cursor: pointer;

}



.site-primary-nav__list a:hover,

.site-primary-nav__list a.is-active {

  color: #25d366 !important;

}



.mobile-menu-toggle {

  display: none;

  flex: 0 0 auto;

  background: none;

  border: none;

  font-size: 24px;

  cursor: pointer;

  color: #075e54;

  padding: 4px 8px;

}



@media (max-width: 1100px) {

  .site-primary-nav__list {

    gap: 12px;

  }



  .site-primary-nav__list a {

    font-size: 0.82rem;

  }

}



@media (max-width: 980px) {

  .mobile-menu-toggle {

    display: block;

  }



  .site-primary-nav {

    display: none;

    position: absolute;

    top: 100%;

    left: 0;

    right: 0;

    padding: 16px 24px 20px;

    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);

  }



  .site-primary-nav--open {

    display: block;

  }



  .site-primary-nav__list {

    flex-direction: column;

    align-items: stretch;

    gap: 12px;

  }



  .site-primary-nav__list a {

    font-size: 1rem;

    padding: 8px 0;

  }



  .site-header__inner {

    position: relative;

    flex-wrap: wrap;

  }

}

</style>


